import { cn } from '@module/lib/utils';

function ButtonSeperator({ className }: { className?: string }) {
  return <div className={cn('h-[20px] w-[1px] border-l border-l-system-gray-300', className)} />;
}

export default ButtonSeperator;
